import { HCustomerService, HTransition, HTransitionGroup } from './index'

function install(Vue) {
  Vue.component('h-customer-service', HCustomerService)
  Vue.component('h-transition', HTransition)
  Vue.component('h-transition-group', HTransitionGroup)
}

export default install
